import { EMPTY_LIST } from '../../../constants/common'
import { ROUTE_UI_SECTION_NAME } from '../../../constants/route'
import { getSectionCanCreatePermission } from '../../../utils/common'

import { LAYOUT_HEADER_ADD_ENTITY_BUTTON_OPTION_VALUE } from './LayoutHeaderAddEntityButton.constants'

import BuildingGroupIcon from '../../../icons/buildings-group.svg'
import DocFlowIcon from '../../../icons/doc-splitting.svg'
import EmailIcon from '../../../icons/email.svg'
import PostIcon from '../../../icons/post.svg'
import ServiceRequestIcon from '../../../icons/service-request.svg'
// import UploadFileIcon from '../../../icons/upload-1.svg'

export function getLayoutHeaderAddEntityButtonOptions({ sections, t }) {
  return [
    ...(getSectionCanCreatePermission(
      sections,
      ROUTE_UI_SECTION_NAME.serviceRequests
    )
      ? [
          {
            Icon: ServiceRequestIcon,
            label: t('Header.CreateEntityBtnServiceRequestOptionLabelKey'),
            value: LAYOUT_HEADER_ADD_ENTITY_BUTTON_OPTION_VALUE.serviceRequest,
          },
        ]
      : EMPTY_LIST),
    ...(getSectionCanCreatePermission(sections, ROUTE_UI_SECTION_NAME.mails)
      ? [
          {
            Icon: EmailIcon,
            label: t('Header.CreateEntityBtnEmailOptionLabelKey'),
            value: LAYOUT_HEADER_ADD_ENTITY_BUTTON_OPTION_VALUE.email,
          },
        ]
      : EMPTY_LIST),
    ...(getSectionCanCreatePermission(sections, ROUTE_UI_SECTION_NAME.newsboard)
      ? [
          {
            Icon: PostIcon,
            label: t('Header.CreateEntityBtnPostOptionLabelKey'),
            value: LAYOUT_HEADER_ADD_ENTITY_BUTTON_OPTION_VALUE.post,
          },
        ]
      : EMPTY_LIST),
    // #TODO Add option after finish https://idwell.atlassian.net/browse/IRD-2812
    // ...(getSectionCanCreatePermission(sections, ROUTE_UI_SECTION_NAME.documents)
    //   ? [
    //       {
    //         Icon: UploadFileIcon,
    //         label: t('Header.CreateEntityBtnFileOptionLabelKey'),
    //         value: LAYOUT_HEADER_ADD_ENTITY_BUTTON_OPTION_VALUE.file,
    //       },
    //     ]
    //   : EMPTY_LIST),
    ...(getSectionCanCreatePermission(sections, ROUTE_UI_SECTION_NAME.docFlows)
      ? [
          {
            Icon: DocFlowIcon,
            label: t('Header.CreateEntityBtnDocFlowOptionLabelKey'),
            value: LAYOUT_HEADER_ADD_ENTITY_BUTTON_OPTION_VALUE.docFlow,
          },
        ]
      : EMPTY_LIST),
    ...(getSectionCanCreatePermission(
      sections,
      ROUTE_UI_SECTION_NAME.buildingGroups
    )
      ? [
          {
            Icon: BuildingGroupIcon,
            label: t('Header.CreateEntityBtnBuildingGroupOptionLabelKey'),
            value: LAYOUT_HEADER_ADD_ENTITY_BUTTON_OPTION_VALUE.buildingGroup,
          },
        ]
      : EMPTY_LIST),
  ]
}
